import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { withTranslation } from 'react-i18next';
import { AppBar, Box, Grid } from '@mui/material';
import logo_only from '../../static/yokohama/logo/hamamo_only_logo.png';
import logo_only_baydiamond from '../../static/yokohama/logo/hamamo_only_logo_baydiamond.png';
import logo_only_delivery from '../../static/yokohama/logo/hamamo_only_logo_delivery.png';

import HeaderYokohama from '../common/HeaderYokohama';
import FooterYokohama from '../common/FooterYokohama';

@inject('orderStore', 'userStore')
@observer
class PaymentErrorDeNAPay extends Component {
  render() {
    const { t, userStore } = this.props;
    return (
      <React.Fragment>
        <AppBar position="fixed" color="header" style={{ boxShadow: 'none' }}>
          <HeaderYokohama />
        </AppBar>

        <Box style={{ marginTop: '63px', backgroundColor: '#F2F2F2', fontFamily: 'Noto Sans JP' }}>
          <Grid container>
            <Grid style={{ padding: '40px', textAlign: 'left' }}>
              <div style={{ textAlign: 'center', display: 'block' }}>
                <img
                  src={
                    userStore.userData.deliveryType === '0'
                      ? logo_only
                      : userStore.userData.deliveryType === '1'
                      ? logo_only_baydiamond
                      : logo_only_delivery
                  }
                  style={{ width: '120px' }}
                  alt=""
                />
              </div>

              <div style={{ fontSize: '20px', fontWeight: 'bold', marginTop: '30px' }}>
                ただいま、サービスにアクセスできません
              </div>

              <div style={{ fontSize: '16px', marginTop: '30px' }}>
                <div style={{ color: 'red' }}>{t('ERROR_FAILED_PAYMENT')}</div>

                <div style={{ marginTop: '30px' }}>
                  申し訳ございませんが、しばらくお待ちいただいてから、再度ページにアクセスください。
                </div>
              </div>

              {/* <div style={{ fontSize: '16px', marginTop: '30px' }}>
                  <img src={arrow} alt="" style={{ marginRight: '3px' }} />
                  モバイルオーダーについて
                </div> */}
            </Grid>
          </Grid>
        </Box>

        <FooterYokohama />
      </React.Fragment>
    );
  }
}

export default withTranslation()(PaymentErrorDeNAPay);
